import React from 'react';
import { TopoLines } from './TopoLines';
type Tome = {
  number: string;
  title: string;
  meetings: string;
  promise: string;
  band: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'No-Start & Hard-Start Diagnostics',
  meetings: 'BC-01–BC-28',
  promise: 'Find the failed Gate before you buy a part.',
  band: 'bg-forest',
  contents: ['The 4-Gate Diagnostic Sequence and the Cheapest-Test-First Rule', 'Intake questions that point you to the right Gate before you pick up a tool', 'No-start cards for walk-behinds, riders, zero-turns, handhelds, snow blowers, generators, tillers, karts and ATVs', 'Hard start cold or hot, only runs on choke, dies when you engage the blade', 'After-storage recovery and the checklist before you write “needs a carb”']
}, {
  number: '02',
  title: 'Running-Fault Diagnostics',
  meetings: 'BC-29–BC-57',
  promise: 'Pin every running fault to speed, load or heat before you touch the carb.',
  band: 'bg-bark',
  contents: ['The Running-Fault Map: RPM × Load × Heat', 'The Surge Isolation Ladder: fuel, air leak, governor, ignition', 'Still surging after a carb clean? Hunt the air leak', 'Power loss, bogging, backfire and smoke color, read the right way', 'Overheating, vibration and faults that come back after release']
}, {
  number: '03',
  title: 'Fuel System & Carburetor Bench Manual',
  meetings: 'BC-58–BC-85',
  promise: 'Decide clean, rebuild or replace with a test, not a guess.',
  band: 'bg-ember-deep',
  contents: ['The Fuel Path Trace: tank to combustion chamber', 'The Carb Decision Gate: adjust, clean, rebuild or replace', 'Float-bowl and diaphragm carbs, torn down and rebuilt step by step', 'Emissions carbs and limiter caps, set within the legal range', 'Contaminated fuel, ethanol and stale-fuel recovery']
}, {
  number: '04',
  title: 'Ignition, Electrical & Safety Systems',
  meetings: 'BC-86–BC-112',
  promise: 'Prove the electrical fault before you replace a part.',
  band: 'bg-signal',
  contents: ['The Spark Quality Scale: none, weak, intermittent, strong', 'Coil tests, air gap, kill wires and the flywheel key', 'The Crank Chain: battery, cables, solenoid, starter and charging', 'The Kill Circuit Map for seat, PTO, brake and lap-bar switches', 'Safety-interlock sign-off — never send a machine out jumped']
}, {
  number: '05',
  title: 'Mechanical Service, Tune-Ups & Storage',
  meetings: 'BC-113–BC-139',
  promise: 'Give a mechanical verdict and send out storage-ready machines.',
  band: 'bg-moss-deep',
  contents: ['Decode model, type and code numbers to find the right official spec', 'The Compression Verdict Chart and leak-down testing', 'Valve lash, head gaskets, crank runout and recoil rebuilds', 'The Seasonal Service Matrix: a tune-up sequence for every machine type', 'Winterizing and off-season storage so it starts next season']
}, {
  number: '06',
  title: 'Shop Paperwork, Estimates & Customer Pickup',
  meetings: 'BC-140–BC-161',
  promise: 'Every job out the door, documented.',
  band: 'bg-pine',
  contents: ['The Pickup-Ready Workflow, from counter intake to follow-up call', 'Repair orders, diagnostic fees and estimates customers understand', 'The Repair-or-Replace Score and the honest “not worth fixing” talk', 'Parts lookup, warranty claims and equipment service history', 'Pickup messages, unclaimed-equipment notices and comeback handling']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="topo-light w-full bg-paper" data-id="element-344" data-mp="rpi8ryvlh0dk">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-345" data-mp="3ran9vuqmzds3">
        <div className="text-center" data-id="element-346" data-mp="3vbp9wdsdntv4">
          <p className="eyebrow text-ember-deep" data-id="element-347" data-mp="3vao16fyu3jgk">From no-start to pickup-ready</p>
          <h2 id="tomes-heading" className="trail-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-348" data-mp="3c8njabfo4213">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-349" data-mp="3lzrtkxueeypl">
            The volumes follow the job through your shop: it comes in dead, it
            runs wrong, you go deep on fuel, electrical or mechanical, and it
            goes back to the customer documented. Each volume stands on its
            own.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-350" data-mp="8q3ytv38e0gu">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-paper-dark bg-white shadow-card" data-id="element-351" data-mp="3tdkbc72rcxj">
              <div className={`relative overflow-hidden ${tome.band}`} data-id="element-352" data-mp="25k74ydvx6kce">
                <TopoLines className="pointer-events-none absolute -right-6 -top-8 h-28 w-28 text-white/20" data-id="element-353" data-mp="l1ef0uq4yxoj" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-354" data-mp="q07swo9c4qp8">
                  <span className="text-[11px] font-bold uppercase tracking-[2px] text-white/90" data-id="element-355" data-mp="bbl9aacodcs7">
                    Volume {tome.number} · {tome.meetings}
                  </span>
                  <span className="font-display text-4xl leading-none text-white" data-id="element-356" data-mp="g8bjwi5png68">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="trail-card flex flex-1 flex-col p-6 pt-5" data-id="element-357" data-mp="6dtftbwdtilw">
                <h3 className="font-display text-2xl uppercase leading-tight text-pine" data-id="element-358" data-mp="3ojesuqidhxa2">
                  {tome.title}
                </h3>
                <p className="mt-1.5 text-sm text-pine-soft" data-id="element-359" data-mp="3tj162zy7bdiv">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-360" data-mp="1mrjjihjla4v0">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-snug text-pine" data-id="element-361" data-mp="1q8o3jo8ojt38">
                      <span className="mt-[6px] h-2 w-2 flex-none rounded-full bg-ember" data-id="element-362" data-mp="1l9kyi3sp9mv9" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}